import React from 'react'
import '../../cssHelper/helper.css'
import '../Frame/Frame.css'
import './Suggession.css'
import { setCategory } from '../../redux/redux'
import { useDispatch } from 'react-redux'

function Suggession() {

    const dispatch = useDispatch();

    return (
        <div className="suggesion-wrapper relative scroll-hidden w-full mt-1">
            <div className="suggessions scroll-x scroll-hidden-y w-full">
                <ul className="flex gap-05 w-full pb-2">
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Fashion Videos
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Dance
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Aasa Kooda
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Cooking Tutorials
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Health & Fitness
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        DIY Projects
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Movie Reviews
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Music Playlists
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Home Decor
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Gardening Tips
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Book Recommendations
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Gaming Streams
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Photography Guides
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Makeup Tutorials
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Parenting Advice
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Educational Content
                    </li>
                    <li onClick={(e) => dispatch(setCategory(e.target.innerHTML))} className="suggessions-li flex a-center j-center pointer r-12 p-inline-1">
                        Pet Care Tips
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Suggession
 